// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fIPNv","tabsBox":"styles_tabsBox__2JhSA","createButton":"styles_createButton__2fOeF"};